"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pdfWebservice = require("./methods/pdfWebservice");

var _config = _interopRequireDefault(require("./configuration/config"));

var _getSettings = _interopRequireDefault(require("./utils/getSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var pdfCreator = function pdfCreator(settings, method, callbackFunction) {
  (0, _pdfWebservice.pdfWebservice)((0, _getSettings["default"])(_config["default"], settings), method, callbackFunction);
};

var _default = pdfCreator;
exports["default"] = _default;